import mapActionToReducer from 'redux-action-reducer-mapper';
import reduceReducers from 'reduce-reducers';

export const initialState = {
	site: {},
	user: {},
	isLoading: true,
	config: {},
	openModals: [],
	breakingErrors: {},
	moduleWidths: {},
	windowWidth: 0,
};

const updateModuleWidths = (state, action) => ({
	...state,
	moduleWidths: {
		...state.moduleWidths,
		[action.payload.moduleName]: action.payload.width,
	},
	windowWidth: window.innerWidth,
});

/**
 * @category Global Redux
 * @subcategory Reducers
 * @module setCoreData
 * @redux
 * @reduxReducer
 */
const setCoreData = (state, action) => ({ ...state, ...action.payload });

/**
 * @category Global Redux
 * @subcategory Reducers
 * @module updateBreakingErrors
 * @redux
 * @reduxReducer
 */
const updateBreakingErrors = (state, action) => ({
	...state,
	breakingErrors: { ...state.breakingErrors, ...action.payload.errors },
});

/**
 * @category Global Redux
 * @subcategory Reducers
 * @module setIsFrontendLoading
 * @redux
 * @reduxReducer
 */
const setIsFrontendLoading = (state, action) => {
	const { isLoading } = action.payload;
	return { ...state, isLoading };
};

/**
 * @category Global Redux
 * @subcategory Reducers
 * @module updateOpenModals
 * @redux
 * @reduxReducer
 */
const updateOpenModals = (state, action) => {
	const { modalId, isOpen } = action.payload;

	return {
		...state,
		openModals: isOpen
			? [...state.openModals, modalId]
			: state.openModals.filter((modal) => modal !== modalId),
	};
};

const updateSiteSettings = (state, action) => {
	const { siteSettings } = action.payload;
	return { ...state, site: { ...state.site, settings: siteSettings } };
};

/**
 * The Combined Reducer
 * @category Global Redux
 * @subcategory Reducers
 * @module globalReducer
 * @redux
 * @reduxReducer
 */
const globalReducer = mapActionToReducer({
	default: initialState,
	SET_CORE_DATA: setCoreData,
	SET_IS_FRONTEND_LOADING: setIsFrontendLoading,
	UPDATE_OPEN_MODALS: updateOpenModals,
	UPDATE_BREAKING_ERRORS: updateBreakingErrors,
	UPDATE_MODULE_WIDTHS: updateModuleWidths,
	UPDATE_SITE_SETTINGS: updateSiteSettings,
	// ...globalDataReducers,
});

export default reduceReducers(globalReducer);
